import React from "react";
import "../styles/Footer.css";
import buttonImage1 from "../assets/appstore.png";
import buttonImage2 from "../assets/googleplay.png";

const Footer = () => {
  const goToPlayStore = () => {
    window.open(
      "https://play.google.com/store",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const goToAppStore = () => {
    window.open(
      "https://www.apple.com/app-store/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <footer className="footer-container">
      <div className="footer-left">
        <h1 className="footer-heading">
          Turn your thoughts
          <span className="gradient-text">
            <br /> into ART.
          </span>
        </h1>
        <div style={{ display: "flex", gap: "5px", marginBottom: "10px" }}>
          <button
            className="footer-button"
            onClick={goToAppStore}
            style={{ border: "none", background: "none", padding: 0 }}
          >
            <img
              src={buttonImage1}
              alt="App Store"
              style={{ width: "100px", height: "auto", cursor: "pointer" }}
            />
          </button>
          <button
            className="footer-button"
            onClick={goToPlayStore}
            style={{ border: "none", background: "none", padding: 0 }}
          >
            <img
              src={buttonImage2}
              alt="Play Store"
              style={{ width: "100px", height: "auto", cursor: "pointer" }}
            />
          </button>
        </div>

        <div style={{ fontSize: 12.5, marginTop: "5px" }}>
          <span className="gradient-text"> katanaInuAIgenerate@</span>{" "}
          <span>2024, All Rights Reserved.</span>
        </div>
      </div>
      <div className="footer-right">
        <div className="footer-column">
          <h2 className="footer-column-title">Resources</h2>
          <a href="#faq" className="footer-link">
            FAQ
          </a>
          <br />
          <br />
          <a href="#pricing" className="footer-link">
            Pricing
          </a>
          <br />
          <br />
          <a href="#features" className="footer-link">
            AI Tools
          </a>
          <br />
          <br />
          <a href="#generation" className="footer-link">
            Generation
          </a>
        </div>
        <div className="footer-column">
          <h2 className="footer-column-title">Services</h2>
          <a href="/process" className="footer-link">
            Image to Image
          </a>
          <br />
          <br />
          <a href="/process" className="footer-link">
            Text To Image
          </a>
          <br />
          <br />
          <a href="/process" className="footer-link">
            ChatBot
          </a>
          <br />
          <br />
          <a href="/process" className="footer-link">
            Image Variation
          </a>
        </div>
        <div className="footer-column">
          <h2 className="footer-column-title">Social Links</h2>
          <a
            href="https://www.instagram.com/katanainu/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Instagram
          </a>
          <br />
          <br />
          <a
            href="https://t.me/katanainu"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Telegram
          </a>
          <br />
          <br />
          <a
            href="https://www.youtube.com/channel/UCD3HhRKj28mj3PxYCwxjddg"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            YouTube
          </a>
          <br />
          <br />
          <a
            href="https://x.com/katanainu"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Twitter
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
